import type { AiCustomPart, AiMessagePart } from 'juneau';
import { ChatNudgeId } from '@insio/shared-types';

/** The offer card the server emits closing a greeting, or the panel shows after a signal. */
export interface NudgePartType extends AiCustomPart {
  type: 'nudge';
  nudgeId: ChatNudgeId;
}

const NUDGE_IDS: readonly string[] = Object.values(ChatNudgeId);

/** True for a nudge part whose id this build knows — an unknown one renders nothing. */
export function isNudgePart(part: AiMessagePart): part is NudgePartType {
  const candidate = part as { type?: unknown; nudgeId?: unknown };
  return (
    candidate.type === 'nudge' &&
    typeof candidate.nudgeId === 'string' &&
    NUDGE_IDS.includes(candidate.nudgeId)
  );
}

/** The offer card part for one nudge. */
export function nudgePart(nudgeId: ChatNudgeId): NudgePartType {
  return { type: 'nudge', nudgeId };
}
